import { storeToRefs } from 'pinia';
import { getStore } from "@/store/index";

// 根据usingStateKey去更改现有的值，适用于通过直接引用组件组成的表单形式
// changeData就是一个对象，包含需要修改的键值对
export const useChangeCsrState = (refList, changeData) => {
  const store = getStore();
  const { csrState } = storeToRefs(store);

  refList.forEach(item => {
      const { usingStateKey } = item?.value ?? {};
      if (usingStateKey) {
        const { cmpName, conf={} } = csrState.value[usingStateKey];
        const key = conf?.name ?? cmpName.replace("-", "");
        if (changeData[key]) {
          store.setCsrStateValue(usingStateKey, changeData[key]);
        }
      }
  })		
}